import React from 'react';
import SidebarDetailHeader from '../SidebarDetailHeader';
import LibraryContent from './LibraryContent';

function LibrarySidebar() {
  return (
    <>
      <SidebarDetailHeader
        title="Library"
      />
      <LibraryContent />
    </>
  );
}

export default LibrarySidebar;